export interface CustomFilterable {
  key: string;
  value: string;
}

/** PENDING DOCUMENT UPLOAD */
export interface DOCUMENT_UPLOAD_FILTER extends CustomFilterable {
  key: "DOCUMENT_UPLOAD",
  value: "TRUE"
}

/** SORT ORDER */
export enum SORT_ORDER {
  ASCENDING = 'asc',
  DESCENDING = 'desc'
}
export interface SORT_ORDER_FILTERABLE extends CustomFilterable {
  key: "SORT_ORDER";
  value: SORT_ORDER;
}

/** ENROLLMENT TYPE */
export enum ENROLLMENT_TYPE {
  OEP = 'oep',
  SEP = 'sep',
  ALL_TYPES = 'all-types'
}
export interface ENROLLMENT_TYPE_FILTERABLE extends CustomFilterable {
  key: "ENROLLMENT_TYPE",
  value: ENROLLMENT_TYPE
}

export interface SearchParams {
  productType?: string;
  agencyId?:string;
  firstName?: string;
  lastName?: string;
  planName?: string;
  fromDate?: string;
  toDate?: string;
  combinedStatus?: string;
  applicationTrackingNumber?: string;
  pageNumber: number;
  countPerPage: number;
  sortingField?: string;
  sortingOrder?: string;
  filter?: CustomFilterable[];
}
